window.Fav = {
	add: function (id) {
		let params = {
			id: id,
			_token: App.csrf,
		};

		$.post('/fav/add_product', params, function (data) {
			Fav.showModalAdded();
			Fav.updateGlobalProductsCounter(data.basket_cnt_products);
			Fav.makeInFav(id);
		});
	},

	del: function (id) {
		let params = {
			id: id,
			_token: App.csrf
		};

		$.post('/fav/del_product', params, function (data) {
			Fav.updateGlobalProductsCounter(data.basket_cnt_products);
			Fav.makeOutFav(id);
		});
	},

	updateGlobalProductsCounter: function (cnt) {
		$('.fav-p-counts').data('cnt', cnt).html(cnt).show();
	},

	showModalAdded: function () {
		let $modal = $("#modal-product-added-fav");
		$modal.modal('show');
	},

	makeInFav: function (id) {
		var $btn = $('button.btn[data-fav][data-action="add"]');
		$btn.addClass('in-fav').find('.text').text('В избранном');

	},
	makeOutFav: function (id) {
		$('.table-fav tr[data-id="'+id+'"]').remove();
		var $btn = $('button.btn[data-fav][data-action="del"]');
		$btn.removeClass('in-fav').find('.text').text('В избранное');
	}
};

$(document).ready(function () {
	$(document).on('click', '[data-fav][data-action="add"]', function () {
		if ($(this).hasClass('in-fav')) {
			location.href = '/account/favorites';
			return false;
		}
		Fav.add($(this).data('id'));
		return false;
	});

	$(document).on('click', '[data-fav][data-action="del"]', function () {
		Fav.del($(this).data('id'));
		return false;
	});
});
